/* global axios */
import ApiClient from './ApiClient';

class AiAgentAPI extends ApiClient {
  constructor() {
    // Base de TODAS as chamadas do Atendente de IA abaixo. Era `typebots`
    // (resíduo do Typebot) até a #933, que trocou o nome em dois passos: o back
    // manteve as duas formas de rota por um release inteiro e só então apagou a
    // velha. `typebots` agora é 404 — este é o único nome que existe.
    super('ai_agents', { accountScoped: true });
  }

  upsertAIAgent(agentBotData) {
    return axios.post(`${this.url}/upsert_ai_agent`, {
      agent_bot: agentBotData,
    });
  }

  // Abre (ou continua) a conversa de teste do agente numa inbox fechada
  testConversation(agentBotId, { mode } = {}) {
    return axios.post(`${this.url}/${agentBotId}/test_conversation`, {
      mode,
    });
  }

  uploadKnowledgeBaseFiles(agentBotId, files) {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files[]', file);
    });

    return axios.post(
      `${this.url}/${agentBotId}/upload_knowledge_base_files`,
      formData
    );
  }

  getVectorStoreFiles(agentBotId, params) {
    return axios.get(`${this.url}/${agentBotId}/get_vector_store_files`, {
      params,
    });
  }

  deleteKnowledgeBaseFile(agentBotId, fileId) {
    return axios.delete(
      `${this.url}/${agentBotId}/knowledge_base_files/${fileId}`
    );
  }

  downloadFile(agentBotId, fileId) {
    return axios.get(
      `${this.url}/${agentBotId}/knowledge_base_files/${fileId}/download`
    );
  }
}

export default new AiAgentAPI();
